import React from 'react'
import { useTranslation } from 'react-i18next'
import MTEMeasurementDataPreview from '../../../../../Measurement/_components/MTE/MTEMeasurementDataPreview'

interface MeasurementDataModalProps {
    _ref: any
    tabledata: any
    literal: string
    onContinue: () => void
    onPrevious: () => void
}

const MTEMeasurementDataModal: React.FC<MeasurementDataModalProps> = ({ _ref, tabledata, literal, onContinue, onPrevious }) => {
    const { t } = useTranslation()
    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box w-11/12 max-w-5xl">
                <MTEMeasurementDataPreview tabledata={tabledata} literal={literal} onContinue={onContinue} onPrevious={onPrevious} />
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default MTEMeasurementDataModal
